module.exports = __webpack_public_path__ + "static/img/3.782c0b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/3.png
// module id = p9G9
// module chunks = 0